import { Flex, Paper, Title } from '@mantine/core';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import classes from '../../../app.module.css';
import { getReportCategoryFromParameter } from '../stores';
import { PercentageChange } from './percentageChange';
import { useNavigate } from 'react-router-dom';
import { useKeycloakStore } from '../../../shared_stores';
import { Parameters } from '@web/common';

export interface parameterCardData {
  parameter: Parameters;
  value: number | undefined;
  unit: string | undefined;
  previousValue?: number;
}

export const ParameterCards = ({ data }: { data: parameterCardData[] }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const ref = useRef<HTMLDivElement>(null);
  const kcStore = useKeycloakStore();
  useEffect(() => {
    function handleScroll(event: Event) {
      if (window.innerWidth < 665) {
        if (ref.current) {
          if (ref.current.scrollLeft !== 0) {
            ref.current.style.borderLeftWidth = '2px';
            if (
              ref.current.scrollWidth <=
              ref.current.offsetWidth + ref.current.scrollLeft
            ) {
              ref.current.style.borderRightWidth = '0';
            } else {
              ref.current.style.borderRightWidth = '2px';
            }
          }
          if (ref.current.scrollLeft === 0) {
            ref.current.style.borderLeftWidth = '0';
          }
        }
      }
    }
    const box = ref.current;
    if (box) {
      box.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (box) {
        box.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const mappedInputs = () => {
    return data.map((entry) => {
      return (
        <Paper
          className={classes.parameterCard}
          onClick={() => {
            if (kcStore.authenticated) {
              void navigate(
                `/reports/${getReportCategoryFromParameter(entry.parameter)}?parameter=${entry.parameter}`,
              );
            }
          }}
        >
          <Flex
            direction={'column'}
            gap={'var(--mantine-spacing-xs)'}
            justify={'space-around'}
            style={{ height: '100%', whiteSpace: 'nowrap' }}
          >
            <Title order={4} style={{ minWidth: 120 }}>
              {t(`reports:${entry.parameter}`)}
            </Title>
            <Title order={2}>
              {entry.value}&nbsp;{entry.unit}
            </Title>
            {entry.value && entry.previousValue && (
              <PercentageChange
                currentValue={entry.value}
                previousValue={entry.previousValue}
              />
            )}
          </Flex>
        </Paper>
      );
    });
  };

  return (
    <Flex
      ref={ref}
      direction={'row'}
      gap={'var(--mantine-spacing-lg)'}
      className={classes.parameterCardsRow}
    >
      {mappedInputs()}
    </Flex>
  );
};
